module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"step":"interview questions list","next":"Next","lostInfoWarning":"Changes not saved will be lost. Are you sure?","continue":"Continue editing","goBack":"Go back","returnToMaster":"Back to the Job question selection","returnToTemplates":"Go back to the Template Selection Wizard"}}')
  delete Component.options._Ctor
}
